// Recent text searches shown on the /search page (Instagram-style "Сүүлийн"
// list) — client-only, no backend endpoint for search history exists.
const STORAGE_KEY = "diil_recent_searches";
const MAX_ITEMS = 10;

export const getRecentSearches = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const persist = (list) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  } catch {
    // localStorage unavailable (private mode etc.) — best-effort only
  }
};

// Adds/moves a term to the front, de-duped case-insensitively, capped at MAX_ITEMS.
export const addRecentSearch = (term) => {
  const trimmed = term.trim();
  if (!trimmed) return getRecentSearches();
  const existing = getRecentSearches();
  const next = [trimmed, ...existing.filter((t) => t.toLowerCase() !== trimmed.toLowerCase())].slice(0, MAX_ITEMS);
  persist(next);
  return next;
};

export const removeRecentSearch = (term) => {
  const next = getRecentSearches().filter((t) => t !== term);
  persist(next);
  return next;
};

export const clearRecentSearches = () => {
  persist([]);
  return [];
};
